module.exports = __webpack_public_path__ + "img/index-process.0b3c01a.png";